const base = "https://static.prod-images.emergentagent.com/jobs/3a0b8376-ae12-498c-94e3-fe2532e66b11/images";

export const IMG = {
  hero: `${process.env.PUBLIC_URL}/office-interior.png`,
  injectables: `${base}/653df14cd8d744ee17deeaddf3c3928c0b3824737d55d508a0d2300116fcb60b.png`,
  facial: `${base}/148aae3174fd5e9fa39c72b8d93b02082718662642fcc685f2c32ed475cd9902.png`,
  body: `${base}/4261976c335a37a87a77b52c3e1b539b88f10341bfad6e05b262c17f8c3deaa5.png`,
  hair: `${base}/598f0c26d0c2c799fb2b539cb50fb4a375a72abff2a22d061a87513b5efde1ed.png`,
  texture: `${base}/2c89a2f4e6c1c30a48d208a528a6879beeb6308e424db14c253eb532c2cfec0d.png`,
};
